import { useState, useMemo, useEffect } from 'react';

const MazeWalker = ({ grid, playerPos, setPlayerPos }) => {
  const directions = useMemo(() => ['N', 'E', 'S', 'W'], []);
  const vectors = useMemo(() => ({ N: [0, -1], E: [1, 0], S: [0, 1], W: [-1, 0] }), []);
  const [facing, setFacing] = useState('E');
  
  function fullLocationName(letter){
    if (letter === 'N')
        return 'North';
    else if (letter === 'S')
        return 'South';
    else if (letter === 'E')
        return 'East';
    else if (letter === 'W')
        return 'West';
  }

  useEffect(() => {
    const handleKey = e => {
      const [dx, dy] = vectors[facing];
      const { x, y } = playerPos;
      const cell = grid[y][x];
      const dirIdx = directions.indexOf(facing);

      if (e.key === 'ArrowLeft') {
        setFacing(d => directions[(directions.indexOf(d) + 3) % 4]);
      } else if (e.key === 'ArrowRight') {
        setFacing(d => directions[(directions.indexOf(d) + 1) % 4]);
      } else if (e.key === 'ArrowUp') {
        if (!cell.walls[dirIdx]) setPlayerPos({ x: x + dx, y: y + dy });
      } else if (e.key === 'ArrowDown') {
        if (!cell.walls[(dirIdx + 2) % 4]) setPlayerPos({ x: x - dx, y: y - dy });
      }
    };

    window.addEventListener('keydown', handleKey);

    return () => window.removeEventListener('keydown', handleKey);

  }, [playerPos, facing, setPlayerPos, directions, vectors, grid]);

  const atStart = playerPos.x === 0 && playerPos.y === 0;

  return (
    <div className="mazeWalker indent">
      <p style={{ fontWeight: 'bold' }}>KEY</p>
      <p>⬅️ / ➡️ – Turn left/right</p>
      <p>⬆️ / ⬇️ – Move forward/backward if no wall blocks the way</p>
      <hr />
      <p>Facing: <strong>{fullLocationName(facing)}</strong>; Location: <strong>({playerPos.x}, {playerPos.y})</strong>;</p>
      {atStart && <p>Currently at Start of Maze...</p>}
    </div>
  );
};

export default MazeWalker;